<script setup>
import { computed, getCurrentInstance, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import KSASecondaryButton from "../../../../components/ui-components/button/KSASecondaryButton.vue";
import KSAPrimaryButton from "../../../../components/ui-components/button/KSAPrimaryButton.vue";
import { useAlertStore } from "../../../../stores/alertStore";
import adminCorpInfoService from "../../../../pages/admin/services/corporation/adminCorpInfoService";
const {$alert, $confirm} = useAlertStore();

const loaded = ref(false);
const router = useRouter()
const { $number, $pageListBoardNo, $yyyymmddHHmmss } = getCurrentInstance().appContext.config.globalProperties;

const list = ref([]);

const searchOpen = ref(true);
const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(0);
const totalCount = ref(0);

const searchInput = ref({ // 검색조건
  searchCorpName: '',
});

// 채용 진행 현황 조회
const retrieveList = () => {
  let paramObj = {
    searchCorpName: searchInput.value.searchCorpName,
    pageNumber: currentPage.value,
    size: pageSize.value,
  }
  //loadingStore.loading = true;
  loaded.value = false;
  adminCorpInfoService.retrieveAllCorpInfoApplicantPaging(paramObj)
      .then( async (res) => {
        loaded.value = true;
        // console.log(res);
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        } else {
        }
      }).catch( (res) =>  {
    console.log(res);
    //loadingStore.loading = false;
    loaded.value = true;
  });
}

const pageSizeGroup = ref([
  { label:'10개씩 보기', value: '10' },
  { label:'30개씩 보기', value: '30' },
  { label:'50개씩 보기', value: '50' },
  { label:'100개씩 보기', value: '100' },
])

// 페이지 선택
const onSelectPage = (pageNo) => {
  currentPage.value = pageNo;
  retrieveList();
}

// 검색조건 - 페이지 사이즈 변경. 10,30,50,100
const onSelectPageSize = (option) => {
  pageSize.value = option.value;
  currentPage.value = 1;

  retrieveList();
}

const clearSearchInput = () => {
  searchInput.value = {
    searchCorpName: '',
  }
}

const onClickSearch = () => {
  currentPage.value = 1;
  retrieveList();
}

onMounted(()=>{
  retrieveList();
})
</script>
<template>
  <div class="content">
    <div class="sub-title">
      <h3>기업홍보관 입사지원 현황</h3>
    </div>

    <!-- s: 검색 -->
    <div class="filter-wrap" :class="{'open': searchOpen}">
      <p @click="searchOpen = !searchOpen">검색</p>
      <div class="filter">
        <dl>
          <dt>
            기업명
          </dt>
          <dd>
            <KSAInput class="text-box" v-model="searchInput.searchCorpName" placeholder="기업명을 입력해 주세요." />
          </dd>
        </dl>
        <div class="btn-wrap">
          <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
          <KSAPrimaryButton text="검색" @click="onClickSearch" />
        </div>
      </div>
    </div>
    <!-- e: 검색 -->
    <div class="list-top">
      <p>전체 <span>{{ $number(totalCount)}}</span>건</p>
      <div>
        <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
      </div>
    </div>

    <div class="table-form">
      <table class="horizontal" v-if="list !== null">
        <colgroup>
          <col />
          <col width="20%" />
          <col />
          <col />
        </colgroup>
        <tr>
          <th rowspan="2">NO</th>
          <th rowspan="2">기업명</th>
          <th rowspan="2">기업홍보관 최초 공개일</th>
          <th colspan="6" class="th-blue">입사지원 현황</th>
        </tr>
        <tr>
          <th class="th-blue border-left">지원완료</th>
          <th class="th-blue">지원취소</th>
          <th class="th-blue">서류합격</th>
          <th class="th-blue">서류불합격</th>
          <th class="th-blue">최종합격</th>
          <th class="th-blue">최종불합격</th>
        </tr>
        <tr v-for="corp in list">
          <td>{{ corp.boardNo }}</td>
          <td class="clickable blue text-overflow">
            <span @click="router.push({name:'CorporationDetail', params:{id: corp.corpId}})">{{corp.corpName}}</span>
          </td>
          <td>{{ $yyyymmddHHmmss(corp.corpInfoAgreePrivacyDate) }}</td>
          <td>{{ corp.applyCompleteCnt }}</td>
          <td>{{ corp.applyCancelCnt }}</td>
          <td>{{ corp.documentPassCnt }}</td>
          <td>{{ corp.documentFailCnt }}</td>
          <td>{{ corp.finalPassCnt }}</td>
          <td>{{ corp.finalFailCnt }}</td>
        </tr>
      </table>
      <div class="result-none" v-if="list.length === 0">
        입사지원 건이 없습니다.
      </div>
    </div>
    <Paginate
        v-if="list.length > 0"
        v-model="currentPage"
        :page-count="totalPages"
        :click-handler="onSelectPage"
    />
  </div>
</template>

<style lang="scss" scoped>
@import "../../../../assets/scss/theme";

.blue {
  color: $blue_color;
}

.clickable {
  text-decoration: underline;
  cursor: pointer;
}
</style>